export default {
  // Page metadata
  meta: {
    keywords: 'environment,green,sustainability,sustainable,renewable resources,corporate social responsibility,sustainability development,sustainable development,green energy,renewal energy sources,green building,green buildings',
    titleTemplate: '%s — Schneider Electric',
    shareTitle: 'Check out the new Schneider Sustainability Report.',
    shareDescription: 'Schneider Electric is combating climate change through innovation. See how EcoStruxure™ solutions are empowering sustainability, boosting bottom lines in every industry, and leading the digital transformation of energy management and automation.'
  },
  // Nav link titles
  nav: {
    Homepage: 'Home',
    Introduction: 'Introduction: Our Mission',
    Introduction_Welcome: 'Introduction: Our Mission', // I question this.
    Introduction_SustainabilityAtSchneiderElectric: 'Sustainability at Schneider Electric',
    Introduction_WorkIndex: '2018 – 2020 Schneider Sustainability Impact',
    Introduction_EnvironmentalStrategy: 'Environmental Strategy',
    LookingAhead_About: 'About This Report',
    SustainableSolutions: 'Sustainable Solutions',
    SustainableSolutions_Overview: 'Sustainable Solutions',
    SustainableSolutions_Ecostruxure: 'EcoStruxure Innovations',
    SustainableSolutions_EnergyServices: 'EcoStruxure Energy & Sustainability Services',
    SustainableSolutions_Research: 'Research & Development',
    SustainableSolutions_EnergyUniversity: 'Energy University',
    SustainableSolutions_SupplyChain: 'Supply Chain',
    OurCustomers: 'Our Customers',
    OurCustomers_Overview: 'Our Customers',
    OurCustomers_Building: 'Building',
    OurCustomers_DataCenter: 'Data Center',
    OurCustomers_Industry: 'Industry',
    OurCustomers_Infrastructure: 'Infrastructure',
    OurPeople: 'Our People',
    OurPeople_Overview: 'Our People',
    OurPeople_CompanyValues: 'Company Values',
    OurPeople_CompanyPrograms: 'Company Programs',
    OurPeople_InvestmentForGrowth: 'Our Investment for Growth',
    OurPeople_LiveLivesBetter: 'We Live Our Lives Better',
    Outreach: 'Outreach and Initiatives',
    Outreach_Overview: 'Outreach and Initiatives',
    Outreach_AccessToEnergy: 'Access to Energy',
    Outreach_SchneiderElectricFoundation: 'Schneider Electric Foundation',
    CompanyPerformance: 'Company Performance',
    CompanyPerformance_Overview: 'Company Performance',
    CompanyPerformance_YearInReview: 'Year In Review',
    CompanyPerformance_20152017PlanetSocietyBarometer: '2015 – 2017 Planet & Society Barometer',
    CompanyPerformance_Leadership: 'Company Leadership',
    CompanyPerformance_Ethics: 'Company Ethics',
    LookingAhead: 'Looking Ahead',
    LookingAhead_Overview: 'Looking Ahead',
    LookingAhead_2018Priorities: '2018 Priorities',
    LookingAhead_SustainabilityApproach: 'An Integrated Approach to Sustainability',

    Prev: 'Previous',
    Next: 'Next',

    title: 'Schneider Sustainability Report 2017 – 2018',
    chapters_heading: 'Chapters',
    sections_heading: 'Sections',
    social_heading: 'Follow Us',

    // Common section translations
    sustainable: {
      title: 'Sustainable solutions'
    }
  }
}



// WEBPACK FOOTER //
// ./src/locale/en.js